import { useEffect, useState } from "react";
import stakContract from "../../../../Contract/stakContract.json";
import zeussToken from "../../../../Contract/zeussToken.json";
import icoContract from "../../../../Contract/ISOContract.json";
import { useAccount } from "wagmi";
import stakeContract from "../../../../Contract/stakContract.json";
import ICOContract from "../../../../Contract/ISOContract.json";
import Reward from "../Modal/Reward";
import Stake from "../Modal/Stake";
import {
  getUserBalances,
  callReadContract,
  formatBalance,
  formatNumber,
  callWriteContract,
  getTxn,
  parsBalance,
} from "../../../../Contract/utils";
import { toast } from "react-toastify";

const Graph = ({ setTxn }) => {
  const user = useAccount();
  const [balance, setBalance] = useState("");
  const [amount, setAmount] = useState("");
  const [stakePer, setStakePers] = useState("");
  const [tokenValue, setTokenValue] = useState("");
  const [totalStaked, setTotalStaked] = useState("");
  const [allTimeStaked, setAllTimeStaked] = useState("");
  const [trans, setTrans] = useState("");

  const getBal = async () => {
    try {
      const bal = await getUserBalances(
        user.address,
        zeussToken.address,
        zeussToken.abi
      );

      setBalance(formatBalance(bal, 18, 2));
    } catch (e) {
      console.log("error in get bal", e);
    }
  };
  const getCurrentValue = async () => {
    try {
      const tokenVal = await callReadContract(
        icoContract.address,
        icoContract.abi,
        "getCurrentPrice"
      );

      setTokenValue(formatBalance(tokenVal.toString(), 6, 6));
    } catch (e) {
      console.log("error in get value", e);
    }
  };
  const totalUserStaked = async () => {
    try {
      const bal = await callReadContract(
        stakContract.address,
        stakContract.abi,
        "getTotalStakedByUser",
        [user.address]
      );

      setTotalStaked(formatBalance(bal, 18, 2));
    } catch (e) {
      console.log("error in get bal", e);
    }
  };

  const allTimeStake = async () => {
    try {
      const bal = await callReadContract(
        stakContract.address,
        stakContract.abi,
        "totalStaked"
      );

      setAllTimeStaked(formatBalance(bal, 18, 2));
    } catch (e) {
      console.log("error in get bal", e);
    }
  };

  useEffect(() => {
    if (user.isConnected && user.address) {
      getBal();
      totalUserStaked();
    }
    getCurrentValue();
    allTimeStake();
  }, [user, trans]);

  return (
    <>
      <section className="StakingGraph">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="stakbalance">
                <div className="row">
                  <div className="col-lg-6 col-md-12">
                    <div className="content">
                      <h4>Staked Balance</h4>
                      <h1>{totalStaked} ZUESS</h1>
                      <h3>${(tokenValue * totalStaked).toFixed(6)}</h3>
                      <div className="img">
                        <img src="./images/line.png" alt="" />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-12">
                    <div className="row">
                      {/* <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="stakecard">
                          <h4>Total Rewards</h4>
                          <h1>0.000ZUESS</h1>
                          <h3>$0.000</h3>
                          <div className="claimbtn">
                            <Reward />
                            <button type="button" className="start">
                              <img src="/images/reward.png" alt="" />
                              Claim Reward
                            </button>
                          </div>
                        </div>
                      </div> */}
                      <div className="offset-lg-6 col-lg-6 col-md-12 col-sm-12">
                        <div className="stakecard">
                          <h4>Your Stakeable</h4>
                          <h1>{balance} ZUESS</h1>
                          <h3>${(balance * tokenValue).toFixed(2)}</h3>
                          <div className="claimbtn">
                            <Stake
                            btn={true}
                              onStake={setTrans}
                              bal={balance}
                              tokenValue={tokenValue}
                              setTxn={setTxn}
                            />
                            {/* <button type="button" className="start">
                              <img src="/images/reward.png" alt="" />
                              Stake Now
                            </button> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row" style={{ marginTop: "20px" }}>
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <div className="stakecard one">
                    <h4>% of Pool</h4>
                    <h1>
                      {((totalStaked / allTimeStaked) * 100).toFixed(4) ||
                        "0.00"}{" "}
                      %
                    </h1>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <div className="stakecard two">
                    <h4>Total Staked</h4>
                    <h1>{formatNumber(allTimeStaked)} ZEUSS</h1>
                    <h3>${(allTimeStaked * tokenValue).toFixed(2)}</h3>
                  </div>
                </div>
                {/* <div className="col-lg-3 col-md-6 col-sm-12">
                  <div className="stakecard three">
                    <h4>Estimated Rewards</h4>
                    <h1>126%p/a</h1>
                    <h3></h3>
                  </div>
                </div> */}
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <div className="stakecard four">
                    <ul>
                      <li>Rewards rate is dynamic</li>
                      <li>Monthly = Rewards % / 12</li>
                      <li>Daily = Rewards % / 365</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Graph;
